import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BehaviorsPage } from './behaviors.page';

const routes: Routes = [
  {
    path: '',
    component: BehaviorsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BehaviorsPageRoutingModule {}
